"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'userList',
  components: {
    Pagination: _Pagination.default,
    selPlat: _selPlat.default,
    drawer: _filter.default
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  data: function data() {
    var _this = this;
    return {
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() < _this.form.end - 29 * 86400 * 1000;
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > _this.form.begin + 29 * 86400 * 1000 || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      },
      form: {
        begin: Date.parse(new Date()) - 29 * 86400 * 1000,
        end: Date.parse(new Date())
      },
      tableMaxH: '250',
      list: [],
      wxapplist: [],
      listLoading: true,
      listQuery: {
        start: 1,
        page_num: 0,
        limit: 15
      },
      memberDialog: false,
      memberObj: {
        status: 1,
        depend_type: 3,
        date_type: 0
      },
      statu: {
        PENDING: "待处理",
        PROCESSING: "处理中",
        PROCESSED: "已处理完成"
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'PCDetail') {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  activated: function activated() {
    if (!this.$route.meta.isBack || !this.list) {
      this.getList();
    }
  },
  mounted: function mounted(options) {
    this.getWxAppList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取小程序列表
     */
    getWxAppList: function getWxAppList() {
      var _this2 = this;
      var url = 'WxOpen/getWxAppList';
      this.$get(url, {}).then(function (res) {
        _this2.wxapplist = res;
      }).catch(function () {});
    },
    /**
     * 获取列表s
     */
    getList: function getList() {
      var _this3 = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/analysis/wx_user_complaints';
      if (listQuery.begin) listQuery.begin_date = this.parseTime(listQuery.begin / 1000, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end_date = this.parseTime(listQuery.end / 1000, '{y}-{m}-{d}');
      this.$get(url, listQuery).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.list;
        if (res.page_num > 0) _this3.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this3.tableMaxH = window.innerHeight - _this3.$refs.order_table.$el.offsetTop - 95;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    /**
     * 充值
     */
    recharge: function recharge(row) {
      var _this4 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.$prompt('请输入充值金额', type == 1 ? '余额充值' : '储值卡充值', {
        confirmButtonText: '确定充值',
        cancelButtonText: '取消',
        inputPlaceholder: '正数为加，负数为减',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this4.loadObj = _this4.$loading({
              lock: true,
              text: '正在充值',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;
            _this4.$post('agentapi/business/invest_user_accout', {
              uid: row.id,
              type: type,
              money: value
            }).then(function (res) {
              _this4.loadObj.close();
              _this4.$message({
                message: '充值成功',
                type: 'success'
              });
              _this4.toQuery();
              done();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 设置会员
     */
    setUserMember: function setUserMember() {
      var _this5 = this;
      var params = this.memberObj;
      this.loadObj = this.$loading({
        lock: true,
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/card/save_user_member_card_info', params).then(function (res) {
        _this5.loadObj.close();
        _this5.$message({
          message: '设置成功',
          type: 'success'
        });
        _this5.memberDialog = false;
      }).catch(function (err) {
        _this5.loadObj.close();
      });
    },
    /**
     * @param {Object} time RFC3339 日期格式
     * RFC3339转为标准格式日期
     */
    RFCToDate: function RFCToDate(time) {
      var date = new Date(time).toJSON();
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
    }
  }
};